module.exports = __webpack_public_path__ + "static/img/zhuanShuKeFu.ad501ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/zhuanShuKeFu.jpg
// module id = GZDO
// module chunks = 1